if (!customElements.get("variant-picker")) {
    class e extends HTMLElement {
        constructor() {
            if (
                (super(),
                (this.selectors = {
                    container: "[data-variant-picker]",
                    productInfo: ".m-product-info--wrapper",
                    error: ".m-product-form-message",
                    variantIdInput: '[name="id"]',
                    pickerFields: ["[data-picker-field]"],
                    optionNodes: [".m-product-option--node"],
                    productSku: "[data-variant-sku]",
                    productAvailability: "[data-availability]",
                    shareUrlInput: "[data-share-url]",
                    stockCountdown: ".prod__stock-countdown",
                    productWrapper: ".m-main-product--wrapper",
                }),
                (this.container = this.closest(this.selectors.container)),
                (this.productWrapper = this.closest(this.selectors.productWrapper)),
                (this.productInfo = this.closest(".bundle-list__item") || this.closest(this.selectors.productInfo)),
                (this.domNodes = queryDomNodes(this.selectors, this.productInfo)),
                document.querySelector(".bundle-list"))
            ) {
                const e = this.dataset.productId;
                document.querySelector(`[data-append-size="${e}"]`).append(this.parentElement);
            }
        }
        connectedCallback() {
            this.setupData();
        }
        async setupData() {
            let e = (window._themeProducts || {})[this.container.dataset.productId];
            (this.productId = this.container.dataset.productId),
                (this.sectionId = this.container.dataset.section),
                (this.productUrl = this.container.dataset.productUrl),
                (this.productHandle = this.container.dataset.productHandle),
                (this.section = this.container.closest(`[data-section-id="${this.sectionId}"]`)),
                (this.variantData = this.getVariantData()),
                (this.preorderData = this.getPreorderData()),
                (this.productData = Object.assign(await this.getProductJson(), e)),
                (this.showFeaturedMedia = "true" === this.dataset.showFeaturedMedia),
                (this.enableVariantGroupImages = "true" === this.container.dataset.enableVariantGroupImages),
                this.enableVariantGroupImages && (this.variantGroupImages = this.getVariantGroupImageData());
            const productForm = Array.from(this.productInfo.querySelectorAll('form[data-product-id]')).find(
                (form) => `${form.dataset.productId}` === `${this.productId}`
            );
            const variantIdInput = productForm?.querySelector(this.selectors.variantIdInput) || this.productInfo.querySelector(this.selectors.variantIdInput);
            const t = variantIdInput?.value;
            (this.currentVariant = this.productData.variants.find((e) => e.id === Number(t))),
                (this.productData.current_variant_id = this.currentVariant && this.currentVariant.id),
                (this.productData.initialVariant = this.currentVariant),
                this.currentVariant && (this.getDataImageVariant(this.currentVariant.id), this.hideSoldOutAndUnavailableOptions(), this.updateButton(!this.currentVariant.available, "", !1)),
                this.currentVariant && this.updatePreorderState(),
                this.getMediaGallery(),
                document.addEventListener("matchMobile", () => {
                    this.getMediaGallery();
                }),
                document.addEventListener("unmatchMobile", () => {
                    this.getMediaGallery();
                }),
                this.initOptionSwatches(),
                this.addEventListener("change", this.onVariantChange);
        }
        getMediaGallery() {
            if (this.productInfo?.classList.contains("bundle-list__item")) return;
            this.mediaGallery = this.section?.querySelectorAll("media-gallery");
            if (!this.mediaGallery || !this.mediaGallery.length) return;
            this.check = setInterval(() => {
                    this.mediaGallery &&
                        this.mediaGallery.forEach((e) => {
                            "none" !== window.getComputedStyle(e).display &&
                                e.mediaMode &&
                                (clearInterval(this.check),
                                (this.layout = e.layout),
                                (this.media = e),
                                "slider" === e.mediaMode ? ((this.slides = e.slider.slides), e.navSlider && (this.slidesNav = e.navSlider.slides)) : (this.mediaItems = e.querySelectorAll(".m-product-media--item")),
                                (!this.showFeaturedMedia || (this.enableVariantGroupImages && this.variantGroupImages.enable)) && this.updateMedia());
                        });
                }, 100);
        }
        onVariantChange() {
            this.getSelectedOptions(),
                this.getSelectedVariant(),
                this.updateButton(!0, "", !1),
                this.updatePickupAvailability(),
                this.removeErrorMessage(),
                this.currentVariant
                    ? (this.getDataImageVariant(this.currentVariant.id),
                      this.updateMedia(),
                      this.updateBrowserHistory(),
                      this.updateVariantInput(),
                      this.updateProductMeta(),
                      this.updatePrice(),
                      this.updateButton(!this.currentVariant.available, window.MinimogStrings.soldOut),
                      this.updatePreorderState(),
                      this.hideSoldOutAndUnavailableOptions())
                    : (this.updateButton(!0, "", !0), this.setUnavailable()),
                window.MinimogEvents.emit(`${this.productId}__VARIANT_CHANGE`, this.currentVariant, this);

            this.closest('.main-product__block-variant_picker')?.classList.remove('main-product__block-variant_picker--error');
        }
        getDataImageVariant(e) {
            this.variantGroupImages && this.variantGroupImages.enable && (this.currentVariantMedia = this.variantGroupImages.mapping.find((t) => Number(t.id) === e).media);
        }
        getProductJson() {
            return fetch(this.productUrl + ".js").then(function (e) {
                return e.json();
            });
        }
        getSelectedVariant() {
            let e = getVariantFromOptionArray(this.productData, this.options),
                t = [...this.options];
            e || (t.pop(), (e = getVariantFromOptionArray(this.productData, t)), e || (t.pop(), (e = getVariantFromOptionArray(this.productData, t))), (this.options = [...e.options]), this.updateSelectedOptions()),
                (this.currentVariant = e);
        }
        getSelectedOptions() {
            const e = Array.from(this.querySelectorAll("[data-picker-field]"));
            this.options = e.map((e) => ("radio" === e.dataset.pickerField ? Array.from(e.querySelectorAll("input")).find((e) => e.checked)?.value : e.querySelector("select").value));
        }
        updateSelectedOptions() {
            this.domNodes.pickerFields.forEach((e, t) => {
                if (e.dataset.selectedValue !== this.options[t]) {
                    const a = e.querySelector(`input[value="${this.options[t].replace(/["\\]/g, "\\$&")}"]`);
                    a && ((a.checked = !0), e.updateSelectedValue());
                }
            });
        }
        updateMedia() {
            if (!this.currentVariant) return;
            let e = [],
                t = [],
                a = 0,
                i = 0,
                s = 0,
                r = 0;
            if (this.variantGroupImages && this.variantGroupImages.enable)
                if ("slider" === this.media.mediaMode && this.slides)
                    this.slides.forEach((t) => {
                        const s = t.querySelector("[data-media-id]").dataset.mediaId;
                        this.currentVariantMedia && this.currentVariantMedia.length > 0
                            ? (this.currentVariantMedia.includes(s) && ((t.dataset.swiperSlideIndex = a++), (t.dataset.index = i++), "0" === t.dataset.swiperSlideIndex && t.classList.add("swiper-slide-active"), e.push(t)),
                              t.classList.contains("media-type-image") || ((t.dataset.swiperSlideIndex = a++), (t.dataset.index = i++), e.push(t)))
                            : ((t.dataset.swiperSlideIndex = a++), (t.dataset.index = i++), e.push(t));
                    }),
                        this.media.slider.removeAllSlides(),
                        this.media.slider.appendSlide(e),
                        "layout-7" == this.layout ? this.media.slider.slideToLoop(1) : this.media.slider.slideToLoop(0),
                        this.media.handleSlideChange(),
                        this.slidesNav &&
                            this.slidesNav.forEach((e) => {
                                const a = e.querySelector("[data-media-id]").dataset.mediaId;
                                this.currentVariantMedia && this.currentVariantMedia.length > 0
                                    ? (this.currentVariantMedia.includes(a) && ((e.dataset.swiperSlideIndex = s++), (e.dataset.index = r++), "0" === e.dataset.swiperSlideIndex && e.classList.add("swiper-slide-thumb-active"), t.push(e)),
                                      e.classList.contains("media-type-image") || ((e.dataset.swiperSlideIndex = s++), (e.dataset.index = r++), t.push(e)))
                                    : ((e.dataset.swiperSlideIndex = s++),
                                      (e.dataset.index = r++),
                                      e.classList.remove("swiper-slide-thumb-active"),
                                      "0" === e.dataset.swiperSlideIndex && e.classList.add("swiper-slide-thumb-active"),
                                      t.push(e));
                            }),
                        this.media.navSlider && this.media.navSlider.removeAllSlides(),
                        this.media.navSlider && this.media.navSlider.appendSlide(t),
                        this.media.navSlider && this.media.navSlider.slideToLoop(0),
                        this.media && this.media.removeAttribute("data-media-loading"),
                        this.media && (this.media.firstElementChild.style.opacity = 1);
                else {
                    let t = 0;
                    const a = this.media.querySelector(".m-product-media--list");
                    this.mediaItems.forEach((i) => {
                        const s = i.querySelector("[data-media-id]").dataset.mediaId;
                        this.currentVariantMedia && this.currentVariantMedia.length > 0
                            ? (this.currentVariantMedia.includes(s) && ((i.dataset.index = t++), e.push(i)), i.classList.contains("media-type-image") || ((i.dataset.index = t++), e.push(i)))
                            : ((i.dataset.index = t++), e.push(i)),
                            (a.innerHTML = ""),
                            e.forEach((e) => {
                                "layout-2" == this.layout && (e.classList.remove("m-col-span-2"), 0 == e.dataset.index % 3 && e.classList.add("m-col-span-2")), a.append(e);
                            });
                    }),
                        this.media && this.media.removeAttribute("data-media-loading"),
                        this.media && (this.media.firstElementChild.style.opacity = 1);
                }
            else parseInt(this.media && this.media.dataset.mediaSize) > 0 && this.media.setActiveMedia(this.currentVariant);
            const n = [];
            e.length > 0 &&
                e.forEach((e, t) => {
                    if ("image" === e.dataset.mediaType) {
                        const t = e.querySelector(".m-product-media").dataset;
                        n.push({ src: t.mediaSrc, width: parseInt(t.mediaWidth), height: parseInt(t.mediaHeight), alt: t.mediaAlt, id: e.dataset.index });
                    } else n.push({ html: `<div class="pswp__${e.dataset.mediaType}">${e.innerHTML}</div>`, type: e.dataset.mediaType, id: e.dataset.index });
                }),
                this.media && this.media.lightbox && this.media.lightbox.destroy(),
                this.media && this.media.handlePhotoswipe(n),
                this.media && this.media.initPhotoswipe();
        }
        updateBrowserHistory() {
            this.currentVariant && "false" !== this.dataset.updateUrl && window.history.replaceState({}, "", `${this.productUrl}?variant=${this.currentVariant.id}`);
        }
        updateVariantInput() {
            const t = Array.from(this.productInfo?.querySelectorAll('form[data-type="add-to-cart-form"]') || []);
            const productForms = t.filter((form) => `${form.dataset.productId || ""}` === `${this.productId}`);
            const a = productForms.length ? productForms : document.querySelectorAll(`#product-form-${this.sectionId}, #product-form-installment`);
            a.forEach((e) => {
                const t = e.querySelector(this.selectors.variantIdInput);
                t && ((t.value = this.currentVariant.id), t.dispatchEvent(new Event("change", { bubbles: !0 })));
            });
        }
        updatePickupAvailability() {
            const e = this.productInfo?.querySelector("pickup-availability");
            e && (this.currentVariant && this.currentVariant.available ? e.fetchAvailability(this.currentVariant.id) : (e.removeAttribute("available"), (e.innerHTML = "")));
        }
        removeErrorMessage() {
            const t = Array.from(this.productInfo?.querySelectorAll("product-form") || []).find((productForm) => {
                const productId = productForm.dataset.productId || productForm.querySelector("form")?.dataset.productId || "";
                return `${productId}` === `${this.productId}`;
            });
            t?.handleErrorMessage?.();
        }
        updatePrice() {
            const e = "m-price--on-sale",
                t = "m-price--sold-out",
                a = this.productInfo.querySelector(".main-product__block-price");
            if (!a) return;
            const i = window.MinimogSettings.money_format,
                { priceWrapper: s, salePrice: r, unitPrice: n, compareAtPrice: d, saleBadge: o, saleAmount: l, unitPriceWrapper: c } = queryDomNodes(
                    {
                        priceWrapper: ".m-price",
                        salePrice: ".m-price-item--sale",
                        compareAtPrice: [".m-price-item--regular"],
                        unitPrice: ".m-price__unit",
                        unitPriceWrapper: ".m-price__unit-wrapper",
                        saleBadge: ".m-price__badge-sale",
                        saleAmount: "[data-saved-price]",
                    },
                    a
                ),
                { compare_at_price: u, price: h, unit_price_measurement: p } = this.currentVariant,
                m = s.dataset.saleBadgeType,
                v = u && u > h,
                g = !this.currentVariant.available;
            if (
                (v ? s.classList.add(e) : s.classList.remove(e),
                g ? s.classList.add(t) : s.classList.remove(t),
                s && s.classList.remove("visibility-hidden"),
                r && (r.innerHTML = formatMoney(h, i)),
                d.length && u > h ? d.forEach((e) => (e.innerHTML = formatMoney(u, i))) : d.forEach((e) => (e.innerHTML = formatMoney(h, i))),
                o && u > h && "text" !== m)
            ) {
                let e;
                if ("fixed_amount" === m) e = formatMoney(u - h, i);
                else {
                    const t = (100 * (u - h)) / u;
                    e = Math.round(t) + "%";
                }
                l.textContent = e;
            }
            if (p && n) {
                c.classList.remove("m:hidden");
                const e = `<span>${formatMoney(this.currentVariant.unit_price, i)}</span>/<span data-unit-price-base-unit>${this._getBaseUnit()}</span>`;
                n.innerHTML = e;
            } else c.classList.add("m:hidden");
        }
        _getBaseUnit = () =>
            1 === this.currentVariant.unit_price_measurement.reference_value
                ? this.currentVariant.unit_price_measurement.reference_unit
                : this.currentVariant.unit_price_measurement.reference_value + this.currentVariant.unit_price_measurement.reference_unit;
        _isPreorderVariant(variantId) {
            let cfg = window._ReStockConfig;

            if(!cfg) return false;

            const po = cfg.pre_order;
            if (!po?.is_service_active || po.limit_reached) return false;

            const map = po.selling_plan_id_to_variant_ids || {};
            const marketMap = po.selling_plan_id_to_market_ids || {};
            const marketId = cfg.marketId;

            return Object.entries(map).some(([planId, ids]) => {
                if (!ids.includes(Number(variantId))) return false;
                const allowed = marketMap[planId];
                if (!allowed || allowed.length === 0 || marketId == null) return true;
                return allowed.includes(marketId);
            });
        }
        updateButton(e = !0, t, a = !0) {
            const isPreorder = this._isPreorderVariant(this.currentVariant.id);
            const scopedForms = Array.from(this.productInfo?.querySelectorAll('form[data-type="add-to-cart-form"]') || []);
            const productForms = scopedForms.filter((form) => `${form.dataset.productId || ""}` === `${this.productId}`);
            const i = productForms.length ? productForms : document.querySelectorAll(`.product-form-${this.sectionId}`);
            i &&
                i.forEach((a) => {
                    const i = a.querySelector('[name="add"]'),
                        s = a.querySelector(".m-product-dynamic-checkout"),
                        r = a.querySelector('[name="add"] > .m-add-to-cart--text');
                    i &&
                        (e
                            ? (i.setAttribute("disabled", "disabled"), i.classList.add("disabled"), s && s.classList.add("disabled"), t && (r.textContent = t))
                            : (i.removeAttribute("disabled"), i.classList.remove("disabled"), s && s.classList.remove("disabled"), (r.textContent = window.MinimogStrings.addToCart)));
                    a.classList.toggle('product--preorder', isPreorder)

                    if(isPreorder) {
                        a.classList.add('product--preorder--temp')

                        setTimeout(() => a.classList.remove('product--preorder--temp'), 600);
                    }
                });
        }
        updateProductMeta() {
            const { available: e, sku: t } = this.currentVariant,
                { inStock: a, outOfStock: i } = window.MinimogStrings,
                s = this.productInfo?.querySelector(this.selectors.productAvailability),
                r = this.productInfo?.querySelector(this.selectors.productSku);
            if ((r && (r.textContent = t || "N/A"), s)) {
                const t = e ? "remove" : "add";
                (s.textContent = e ? a : i), s.classList[t]("m-product-availability--outofstock");
            }
        }
        setUnavailable() {
            const e = Array.from(this.productInfo?.querySelectorAll('form[data-type="add-to-cart-form"]') || []).find(
                    (form) => `${form.dataset.productId || ""}` === `${this.productId}`
                ) || document.getElementById(`product-form-${this.sectionId}`),
                t = e?.querySelector('[name="add"]'),
                a = e?.querySelector('[name="add"] > span.m-add-to-cart--text'),
                i = this.productInfo?.querySelector(".m-price");
            t && ((a.textContent = window.MinimogStrings.unavailable), i && i.classList.add("visibility-hidden"));
        }
        hideSoldOutAndUnavailableOptions = () => {
            const e = "m-product-option--node__unavailable",
                t = this.currentVariant,
                { optionNodes: a } = this.domNodes,
                {
                    productData: i,
                    productData: {
                        variants: s,
                        options: { length: r },
                    },
                } = this;
            a.forEach((a) => {
                const { optionPosition: n, value: d } = a.dataset,
                    o = Number(n),
                    l = "OPTION" === a.tagName;
                let c = [];
                if (o === r) {
                    const e = Array.from(t.options);
                    (e[r - 1] = d), c.push(getVariantFromOptionArray(i, e));
                } else c = s.filter((e) => e.options[o - 1] === d && e.options[o - 2] === t["option" + (o - 1)]);
                if (((c = c.filter(Boolean)), c.length)) {
                    a.classList.remove(e), l && a.removeAttribute("disabled");
                    const t = c.every((e) => !1 === e.available) ? "add" : "remove";
                    a.classList[t]("m-product-option--node__soldout");
                } else a.classList.add(e), l && a.setAttribute("disabled", "true");
            });
        };
        getVariantData() {
            return (this.variantData = this.variantData || JSON.parse(this.container.querySelector('#productVariants[type="application/json"]').textContent)), this.variantData;
        }
        getPreorderData() {
            const e = this.container.querySelector('#productPreorderVariants[type="application/json"]');
            return e ? JSON.parse(e.textContent) : {};
        }
        getVariantGroupImageData() {
            return (this.variantGroupImages = this.variantGroupImages || JSON.parse(this.container.querySelector('#variantGroup[type="application/json"]').textContent)), this.variantGroupImages;
        }
        updatePreorderState() {
            const e = this.preorderData[this.currentVariant.id] === true;
            this.container.dataset.preorder = e;
            this.dataset.preorder = e;
            this.productInfo?.dispatchEvent(
                new CustomEvent("variant:preorder-change", {
                    bubbles: !0,
                    detail: {
                        preorder: e,
                        variant: this.currentVariant,
                        variantId: this.currentVariant.id,
                        productId: this.productId,
                        sectionId: this.sectionId,
                    },
                })
            );
        }
        initOptionSwatches() {
            const { _colorSwatches: e = [], _imageSwatches: t = [] } = window.MinimogSettings;
            this.domNodes.optionNodes &&
                this.domNodes.optionNodes.forEach((a) => {
                    const { optionType: i, optionPosition: s, value: r } = a.dataset,
                        n = r.toLowerCase(),
                        d = this.variantData.find((e) => e[`option${s}`] === r),
                        o = d && d.featured_image && d.featured_image.src && !d.featured_image.src.includes(".webp") ? getSizedImageUrl(d.featured_image.src, "100x") : d?.featured_image ? d?.featured_image.src : null,
                        l = t.find((e) => e.key === n) ? t.find((e) => e.key === n).value : "",
                        c = e.find((e) => e.key === n) ? e.find((e) => e.key === n).value : "";
                    switch (((o || l) && a.querySelector("label") && a.querySelector("label").classList.add("has-bg-img"), i)) {
                        case "default":
                            (a.querySelector("label").style.backgroundImage = `url(${l || o || ""})`), a.querySelector("label").classList.remove("option-loading");
                            break;
                        case "image":
                            (a.querySelector("label").style.backgroundImage = `url(${o || l || ""})`), a.querySelector("label").classList.remove("option-loading");
                            break;
                        case "color":
                            (a.querySelector("label").style.backgroundColor = c || n), l && (a.querySelector("label").style.backgroundImage = `url(${l})`), a.querySelector("label").classList.remove("option-loading");
                    }
                });
        }
    }
    customElements.define("variant-picker", e);
}
if (!customElements.get("variant-button")) {
    class e extends HTMLElement {
        constructor() {
            super(), (this.selectedSpan = this.querySelector(".option-label--selected")), this.addEventListener("change", this.updateSelectedValue);
        }
        updateSelectedValue() {
            const e = Array.from(this.querySelectorAll("input")).find((e) => e.checked);
            if (!e) return;

            const t = e.dataset.variantId;
            this.selectedSpan && (this.selectedSpan.textContent = e.value);
            const a = this.dataset.productId,
                i = document.querySelector(`form[data-product-id="${a}"]`)?.querySelector('input[name="id"]');
            i && (i.value = t);

            if (e.name === 'Size') {
                const key = 'productSize';
                localStorage.removeItem(key);
                localStorage.setItem(key, e.value.replace(/[^0-9.]/g, ''));
            };
        }
    }
    if ((customElements.define("variant-button", e), !customElements.get("variant-select"))) {
        class t extends e {
            constructor() {
                super();
            }
            updateSelectedValue() {
                (this.value = this.querySelector("select").value), this.setAttribute("data-selected-value", this.value), this.selectedSpan && (this.selectedSpan.textContent = this.value);
            }
        }
        customElements.define("variant-select", t);
    }
    if (!customElements.get("variant-image")) {
        class t extends e {
            constructor() {
                super();
            }
        }
        customElements.define("variant-image", t);
    }
    if (!customElements.get("variant-color")) {
        class t extends e {
            constructor() {
                super();
            }
        }
        customElements.define("variant-color", t);
    }
}
